import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/** Envoie les cookies httpOnly (refresh token) sur les appels API OGESTE. */
export function CredentialsInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {
  const apiOrigin = environment.apiUrl.replace(/\/api\/?$/, '');

  if (request.url.startsWith(environment.apiUrl) || request.url.startsWith(apiOrigin)) {
    request = request.clone({ withCredentials: true });
  }

  return next(request);
}
